export const images = {
  hero: "/images/real/independence-day-march-3.jpg",
  portrait: "/images/real/sanjay-sharma-portrait.jpg",
  health: "/images/real/natural-therapy-camp.jpg",
  education: "https://images.unsplash.com/photo-1524069290683-0457abfe42c3?auto=format&fit=crop&w=1200&q=80",
  women: "/images/real/republic-day-family.jpg",
  trees: "/images/real/jal-chhatra-seva-camp.jpg",
};

// Hero carousel slides (Ken Burns crossfade). First slide matches images.hero
// so there is no flash on load.
export const heroSlides = [
  {
    src: "/images/real/independence-day-march-3.jpg",
    caption: { en: "Independence Day 2026: Flag March", hi: "स्वतंत्रता दिवस 2026: ध्वज मार्च" },
  },
  {
    src: "/images/real/kamal-watch-inauguration-1.jpg",
    caption: { en: "Kamal Watch Company: Showroom Inauguration", hi: "कमल वॉच कंपनी: शोरूम उद्घाटन" },
  },
  {
    src: "/images/real/akhil-bhartiya-samilani-2.jpg",
    caption: { en: "Akhil Bhartiya Samilani: Felicitating The Saints", hi: "अखिल भारतीय सम्मिलनी: संतों का अभिनंदन" },
  },
  {
    src: "/images/real/blood-donation-day.jpg",
    caption: { en: "World Blood Donor Day Camp", hi: "विश्व रक्तदाता दिवस शिविर" },
  },
  {
    src: "/images/real/matrushakti-gangaur-fair-1.jpg",
    caption: { en: "Matr Shakti: Gangaur Fair & Exhibition", hi: "मातृशक्ति: गणगौर मेला एवं प्रदर्शनी" },
  },
  {
    src: "/images/real/republic-day-3.jpg",
    caption: { en: "Republic Day 2026: Community Gathering", hi: "गणतंत्र दिवस 2026: सामुदायिक सभा" },
  },
];

export const contact = {
  phoneDisplay: "+91 90919 22700",
  phoneHref: "tel:+919091922700",
  whatsapp: "https://wa.me/919091922700",
  email: "help@sanjaysharma.org",
  office: {
    en: "Marwari Club, Manik Ghosh Bazar, Cuttack-753002, Odisha",
    hi: "मारवाड़ी क्लब, माणिक घोष बाजार, कटक-753002, ओडिशा",
  },
};

export const content = {
  nav: {
    about: { en: "About", hi: "परिचय" },
    priorities: { en: "Priorities", hi: "प्राथमिकताएं" },
    gallery: { en: "Gallery", hi: "गैलरी" },
    news: { en: "In The News", hi: "समाचारों में" },
    contact: { en: "Contact", hi: "संपर्क" },
    join: { en: "Join the Community", hi: "समुदाय से जुड़ें" },
    menu: { en: "Menu", hi: "मेनू" },
    close: { en: "Close", hi: "बंद करें" },
  },
  hero: {
    eyebrow: { en: "Official Public Portfolio", hi: "आधिकारिक जनसेवा पोर्टल" },
    nameLines: { en: ["Sanjay", "Sharma"], hi: ["संजय", "शर्मा"] },
    tagline: {
      en: "Serving People with Compassion and Integrity",
      hi: "करुणा और निष्ठा के साथ जनसेवा में समर्पित",
    },
    sub: {
      en: "Dedicated to community welfare, youth enablement, and grassroots healthcare through active CSR and NGO initiatives.",
      hi: "सक्रिय सीएसआर और एनजीओ पहलों के माध्यम से सामुदायिक कल्याण, युवा सशक्तिकरण और जमीनी स्वास्थ्य सेवाओं के लिए प्रतिबद्ध।",
    },
    ctaPrimary: { en: "Join the Community", hi: "समुदाय से जुड़ें" },
    ctaSecondary: { en: "Explore Priorities", hi: "प्राथमिकताएं देखें" },
    scroll: { en: "Scroll to explore", hi: "जानने के लिए स्क्रॉल करें" },
  },
  identity: [
    {
      label: { en: "Location", hi: "स्थान" },
      value: { en: "Cuttack, Odisha", hi: "कटक, ओडिशा" },
    },
    {
      label: { en: "Designation", hi: "पदनाम" },
      value: { en: "President, Cuttack Marwari Samaj (2024-26)", hi: "अध्यक्ष, कटक मारवाड़ी समाज (2024-26)" },
    },
    {
      label: { en: "Community", hi: "समुदाय" },
      value: { en: "Marwari Samaj · Founded 2009", hi: "मारवाड़ी समाज · स्थापना 2009" },
    },
    {
      label: { en: "Focus", hi: "कार्यक्षेत्र" },
      value: { en: "Community Service & Philanthropy", hi: "समाजसेवा एवं परोपकार" },
    },
  ],
  about: {
    eyebrow: { en: "Chapter 01: The Man", hi: "अध्याय 01: व्यक्तित्व" },
    headline: {
      en: "A Life Rooted in Generous Service & Grassroots Advocacy",
      hi: "जनसेवा और जमीनी वकालत में समर्पित जीवन",
    },
    paragraphs: {
      en: [
        "Sanjay Sharma is a Cuttack-based jewellery businessman, son of noted businessman Hemraj Sharma, and a founder member of Cuttack Marwari Samaj (est. 2009). On 1 August 2024 he was elected the Samaj's President for the 2024-26 term, polling 1,531 of 2,219 votes cast, and was sworn in on 10 August 2024 at the SGBL Megamart auditorium, CDA Sector-1, in a ceremony administered by chief guest Sudarshan Goyal, Treasurer of the BJP's Odisha unit.",
        "He is the first-time President of an organisation that today counts over 7,000 members and is registered under the Odisha Society Registration Act (No. 23773/07). He also serves as President of the Utkal Gaur Brahmin Sabha. Under his leadership the Samaj continues its work across health camps, education, festivals, and community relief for the Marwari community of Cuttack and Odisha.",
      ],
      hi: [
        "संजय शर्मा कटक के जौहरी व्यवसायी हैं, प्रतिष्ठित व्यवसायी हेमराज शर्मा के पुत्र हैं, और कटक मारवाड़ी समाज (स्थापना 2009) के संस्थापक सदस्य हैं। 1 अगस्त 2024 को वे समाज के 2024-26 कार्यकाल के लिए अध्यक्ष चुने गए, कुल 2,219 मतों में से 1,531 मत प्राप्त कर, और 10 अगस्त 2024 को एसजीबीएल मेगामार्ट सभागार, सीडीए सेक्टर-1 में शपथ ग्रहण की, जहां भाजपा ओडिशा इकाई के कोषाध्यक्ष सुदर्शन गोयल ने मुख्य अतिथि के रूप में शपथ दिलाई।",
        "वे ऐसे संगठन के प्रथम बार अध्यक्ष हैं जिसके आज 7,000 से अधिक सदस्य हैं और जो ओडिशा सोसाइटी पंजीकरण अधिनियम (पंजीकरण संख्या 23773/07) के अंतर्गत पंजीकृत है। वे उत्कल गौड़ ब्राह्मण सभा के अध्यक्ष भी हैं। उनके नेतृत्व में समाज स्वास्थ्य शिविर, शिक्षा, पर्व एवं सामुदायिक राहत कार्यों में निरंतर सक्रिय है।",
      ],
    },
    quote: {
      en: "Empowering communities through generous service & dedicated leadership.",
      hi: "निस्वार्थ सेवा और समर्पित नेतृत्व से सशक्त बनता समाज।",
    },
    caption: {
      en: "Sanjay Sharma, President, Cuttack Marwari Samaj (2024-26)",
      hi: "संजय शर्मा, अध्यक्ष, कटक मारवाड़ी समाज (2024-26)",
    },
  },
  priorities: {
    eyebrow: { en: "Chapter 02: The Manifesto", hi: "अध्याय 02: घोषणापत्र" },
    heading: { en: "Four Core Priorities", hi: "चार प्रमुख प्राथमिकताएं" },
    sub: {
      en: "Not promises on paper. Programs already running on the ground.",
      hi: "कागज़ पर वादे नहीं। ज़मीन पर पहले से चल रहे कार्यक्रम।",
    },
    items: [
      {
        num: "01",
        title: { en: "Health & Wellness Camps", hi: "स्वास्थ्य एवं आरोग्य शिविर" },
        desc: {
          en: "Free medical and wellness camps across Cuttack, including Ayurvedic acupressure and acupuncture treatment camps at the Marwari Club, offering diagnostics and care at no cost to residents.",
          hi: "कटक भर में नि:शुल्क चिकित्सा एवं आरोग्य शिविर, जिसमें मारवाड़ी क्लब में आयुर्वेदिक एक्यूप्रेशर एवं एक्यूपंक्चर उपचार शिविर शामिल हैं, नागरिकों को निःशुल्क जांच एवं देखभाल।",
        },
        metric: { en: "Free Camps Every Year", hi: "प्रतिवर्ष नि:शुल्क शिविर" },
        image: "health",
      },
      {
        num: "02",
        title: { en: "Education & Library", hi: "शिक्षा एवं पुस्तकालय" },
        desc: {
          en: "Computer training for students, sponsorship for meritorious children, drawing competitions, and a community library established in December 2021 at the Marwari Club.",
          hi: "छात्रों के लिए कंप्यूटर प्रशिक्षण, मेधावी बच्चों के लिए शिक्षा प्रायोजन, चित्रकला प्रतियोगिताएं, और दिसंबर 2021 में मारवाड़ी क्लब में स्थापित सामुदायिक पुस्तकालय।",
        },
        metric: { en: "Library Est. Dec 2021", hi: "पुस्तकालय स्थापना दिसंबर 2021" },
        image: "education",
      },
      {
        num: "03",
        title: { en: "Festivals & Community Unity", hi: "पर्व एवं सामुदायिक एकता" },
        desc: {
          en: "The Independence Day flag march, Ganesh Utsav with Garba, Diwali Bandhu Milan, and Durga idol immersion service camps bring the Marwari community together each year.",
          hi: "स्वतंत्रता दिवस ध्वजारोहण मार्च, गरबा सहित गणेश उत्सव, दीपावली बंधु मिलन, और दुर्गा प्रतिमा विसर्जन सेवा शिविर हर वर्ष मारवाड़ी समाज को एकजुट करते हैं।",
        },
        metric: { en: "7,000+ Members Strong", hi: "7,000+ सदस्य" },
        image: "women",
      },
      {
        num: "04",
        title: { en: "Social Welfare & Relief", hi: "सामाजिक कल्याण एवं राहत" },
        desc: {
          en: "Mass food distribution during Puri's Rath Yatra and Bahudia Yatra, COVID-19 relief for migrant workers (2020-22), and GST awareness seminars for local businesses.",
          hi: "पुरी की रथ यात्रा एवं बाहुड़ा यात्रा के दौरान सामूहिक भोजन वितरण, प्रवासी श्रमिकों के लिए कोविड-19 राहत (2020-22), और स्थानीय व्यवसायों हेतु जीएसटी जागरूकता सेमिनार।",
        },
        metric: { en: "Est. 2009 · Regd. No. 23773/07", hi: "स्थापना 2009 · पंजीयन सं. 23773/07" },
        image: "trees",
      },
    ],
  },
  gallery: {
    eyebrow: { en: "Chapter 04: On The Ground", hi: "अध्याय 04: ज़मीनी कार्य" },
    heading: { en: "Gallery & Community Outreach", hi: "गैलरी एवं जनसंपर्क" },
    items: [
      {
        src: "/images/real/independence-day-flag-march.jpg",
        caption: { en: "Independence Day 2026: Flag March Volunteers", hi: "स्वतंत्रता दिवस 2026: ध्वज मार्च स्वयंसेवक" },
      },
      {
        src: "/images/real/independence-day-i-am-indian.jpg",
        caption: { en: "Independence Day 2026: I Am Indian", hi: "स्वतंत्रता दिवस 2026: मैं भारतीय हूं" },
      },
      {
        src: "/images/real/republic-day-young-patriot.jpg",
        caption: { en: "Republic Day 2026: Young Patriots", hi: "गणतंत्र दिवस 2026: युवा देशभक्त" },
      },
      {
        src: "/images/real/republic-day-flag-hoisting.jpg",
        caption: { en: "Republic Day 2026: Flag Hoisting", hi: "गणतंत्र दिवस 2026: ध्वजारोहण" },
      },
      {
        src: "/images/real/jal-chhatra-seva-inauguration.jpg",
        caption: { en: "Jal Chhatra Seva: Camp Inauguration", hi: "जल छत्र सेवा: शिविर उद्घाटन" },
      },
      {
        src: "/images/real/jal-chhatra-seva-camp.jpg",
        caption: { en: "Jal Chhatra Seva: Cold Drinking Water Camp", hi: "जल छत्र सेवा: शीतल पेय जल शिविर" },
      },
      {
        src: "/images/real/jal-chhatra-seva-distribution.jpg",
        caption: { en: "Jal Chhatra Seva: Serving The Community", hi: "जल छत्र सेवा: समुदाय की सेवा" },
      },
      {
        src: "/images/real/natural-therapy-camp.jpg",
        caption: { en: "Natural Therapy & Chiropractic Camp", hi: "प्राकृतिक चिकित्सा एवं कायरोप्रैक्टिक शिविर" },
      },
      {
        src: "/images/real/independence-day-march-2.jpg",
        caption: { en: "Independence Day 2026: Marching Together", hi: "स्वतंत्रता दिवस 2026: साथ मार्च" },
      },
      {
        src: "/images/real/independence-day-march-4.jpg",
        caption: { en: "Independence Day 2026: Community Assembly", hi: "स्वतंत्रता दिवस 2026: सामुदायिक सभा" },
      },
      {
        src: "/images/real/independence-day-march-5.jpg",
        caption: { en: "Independence Day 2026: Saluting The Flag", hi: "स्वतंत्रता दिवस 2026: ध्वज को सलामी" },
      },
      {
        src: "/images/real/independence-day-march-6.jpg",
        caption: { en: "Independence Day 2026: Closing Moments", hi: "स्वतंत्रता दिवस 2026: समापन क्षण" },
      },
      {
        src: "/images/real/jal-chhatra-seva-setup.jpg",
        caption: { en: "Jal Chhatra Seva: Camp Set-Up", hi: "जल छत्र सेवा: शिविर स्थापना" },
      },
      {
        src: "/images/real/jal-chhatra-seva-volunteers.jpg",
        caption: { en: "Jal Chhatra Seva: Volunteers On Duty", hi: "जल छत्र सेवा: सेवारत स्वयंसेवक" },
      },
      {
        src: "/images/real/jal-chhatra-seva-serving.jpg",
        caption: { en: "Jal Chhatra Seva: Serving Cold Water", hi: "जल छत्र सेवा: शीतल जल वितरण" },
      },
      {
        src: "/images/real/jal-chhatra-seva-crowd.jpg",
        caption: { en: "Jal Chhatra Seva: Community Turnout", hi: "जल छत्र सेवा: सामुदायिक भागीदारी" },
      },
      {
        src: "/images/real/jal-chhatra-seva-closing.jpg",
        caption: { en: "Jal Chhatra Seva: Closing Ceremony", hi: "जल छत्र सेवा: समापन समारोह" },
      },
      {
        src: "/images/real/natural-therapy-camp-2.jpg",
        caption: { en: "Natural Therapy Camp: Free Consultations", hi: "प्राकृतिक चिकित्सा शिविर: नि:शुल्क परामर्श" },
      },
      {
        src: "/images/real/natural-therapy-camp-4.jpg",
        caption: { en: "Natural Therapy Camp: Patients In Care", hi: "प्राकृतिक चिकित्सा शिविर: रोगी देखभाल" },
      },
      {
        src: "/images/real/republic-day-2.jpg",
        caption: { en: "Republic Day 2026: Community Gathering", hi: "गणतंत्र दिवस 2026: सामुदायिक सभा" },
      },
      {
        src: "/images/real/republic-day-3.jpg",
        caption: { en: "Republic Day 2026: Members In Attendance", hi: "गणतंत्र दिवस 2026: उपस्थित सदस्यगण" },
      },
      {
        src: "/images/real/republic-day-4.jpg",
        caption: { en: "Republic Day 2026: Cultural Program", hi: "गणतंत्र दिवस 2026: सांस्कृतिक कार्यक्रम" },
      },
      {
        src: "/images/real/republic-day-5.jpg",
        caption: { en: "Republic Day 2026: Address To The Samaj", hi: "गणतंत्र दिवस 2026: समाज को संबोधन" },
      },
      {
        src: "/images/real/republic-day-6.jpg",
        caption: { en: "Republic Day 2026: Honouring Volunteers", hi: "गणतंत्र दिवस 2026: स्वयंसेवक सम्मान" },
      },
      {
        src: "/images/real/republic-day-7.jpg",
        caption: { en: "Republic Day 2026: Flag Hoisting Ceremony", hi: "गणतंत्र दिवस 2026: ध्वजारोहण समारोह" },
      },
      {
        src: "/images/real/republic-day-8.jpg",
        caption: { en: "Republic Day 2026: Community Photograph", hi: "गणतंत्र दिवस 2026: सामूहिक तस्वीर" },
      },
      {
        src: "/images/real/republic-day-9.jpg",
        caption: { en: "Republic Day 2026: Children's Participation", hi: "गणतंत्र दिवस 2026: बच्चों की भागीदारी" },
      },
      {
        src: "/images/real/republic-day-10.jpg",
        caption: { en: "Republic Day 2026: Closing Salute", hi: "गणतंत्र दिवस 2026: समापन सलामी" },
      },
      {
        src: "/images/real/matrushakti-gangaur-fair-1.jpg",
        caption: { en: "Matr Shakti: Gangaur Fair & Exhibition", hi: "मातृशक्ति: गणगौर मेला एवं प्रदर्शनी" },
      },
      {
        src: "/images/real/matrushakti-gangaur-fair-2.jpg",
        caption: { en: "Matr Shakti: Stalls & Cultural Showcase", hi: "मातृशक्ति: स्टॉल एवं सांस्कृतिक प्रस्तुति" },
      },
      {
        src: "/images/real/sukhi-sang-1.jpg",
        caption: { en: "Sukhi Sang: Community Felicitation", hi: "सुखी संग: सामुदायिक सम्मान समारोह" },
      },
      {
        src: "/images/real/sukhi-sang-2.jpg",
        caption: { en: "Sukhi Sang: Members In Celebration", hi: "सुखी संग: उत्सव में सदस्यगण" },
      },
      {
        src: "/images/real/sanjay-sharma-formal.jpg",
        caption: { en: "Sanjay Sharma, President, Cuttack Marwari Samaj", hi: "संजय शर्मा, अध्यक्ष, कटक मारवाड़ी समाज" },
      },
      {
        src: "/images/real/blood-donation-day.jpg",
        caption: { en: "World Blood Donor Day Camp", hi: "विश्व रक्तदाता दिवस शिविर" },
      },
      {
        src: "/images/real/akhil-bhartiya-samilani-1.jpg",
        caption: { en: "Akhil Bhartiya Samilani: Srila Prabhupada Centenary", hi: "अखिल भारतीय सम्मिलनी: श्रील प्रभुपाद शताब्दी समारोह" },
      },
      {
        src: "/images/real/akhil-bhartiya-samilani-2.jpg",
        caption: { en: "Akhil Bhartiya Samilani: Felicitating The Saints", hi: "अखिल भारतीय सम्मिलनी: संतों का अभिनंदन" },
      },
      {
        src: "/images/real/akhil-bhartiya-samilani-3.jpg",
        caption: { en: "Akhil Bhartiya Samilani: Traditional Welcome", hi: "अखिल भारतीय सम्मिलनी: पारंपरिक स्वागत" },
      },
      {
        src: "/images/real/akhil-bhartiya-samilani-4.jpg",
        caption: { en: "Akhil Bhartiya Samilani: Honour & Citation", hi: "अखिल भारतीय सम्मिलनी: सम्मान एवं प्रशस्ति पत्र" },
      },
      {
        src: "/images/real/akhil-bhartiya-samilani-5.jpg",
        caption: { en: "Akhil Bhartiya Samilani: Community Gathering", hi: "अखिल भारतीय सम्मिलनी: सामुदायिक जमावड़ा" },
      },
      {
        src: "/images/real/saraswati-vidya-mandir-function-1.jpg",
        caption: { en: "Saraswati Sishu Vidya Mandir: Annual Function", hi: "सरस्वती शिशु विद्या मंदिर: वार्षिकोत्सव" },
      },
      {
        src: "/images/real/saraswati-vidya-mandir-function-2.jpg",
        caption: { en: "Saraswati Sishu Vidya Mandir: Prize Distribution", hi: "सरस्वती शिशु विद्या मंदिर: पुरस्कार वितरण" },
      },
      {
        src: "/images/real/saraswati-vidya-mandir-function-3.jpg",
        caption: { en: "Saraswati Sishu Vidya Mandir: Cultural Dance", hi: "सरस्वती शिशु विद्या मंदिर: सांस्कृतिक नृत्य" },
      },
      {
        src: "/images/real/kamal-watch-inauguration-1.jpg",
        caption: { en: "Kamal Watch Company: Showroom Inauguration", hi: "कमल वॉच कंपनी: शोरूम उद्घाटन" },
      },
      {
        src: "/images/real/kamal-watch-inauguration-2.jpg",
        caption: { en: "Kamal Watch Company: Inside The New Showroom", hi: "कमल वॉच कंपनी: नए शोरूम में" },
      },
    ],
    closeLabel: { en: "Close", hi: "बंद करें" },
  },
  news: {
    eyebrow: { en: "As Seen In", hi: "मीडिया में" },
    heading: { en: "In The News", hi: "समाचारों में" },
    sub: {
      en: "Coverage of the Samaj's health camps, community service, and civic honours in the local Odia and English press.",
      hi: "स्थानीय ओड़िया एवं अंग्रेजी प्रेस में समाज के स्वास्थ्य शिविरों, समाजसेवा एवं नागरिक सम्मान की कवरेज।",
    },
    items: [
      {
        src: "/images/news/news-clip-atal-odisha-icon-award.jpg",
        caption: {
          en: "Sanmarg: Atal Odisha Icon Award Coverage",
          hi: "सन्मार्ग: अटल ओडिशा आइकन अवार्ड कवरेज",
        },
      },
      {
        src: "/images/news/news-clip-independence-day-2025.jpg",
        caption: { en: "Independence Day 2025 Report", hi: "स्वतंत्रता दिवस 2025 रिपोर्ट" },
      },
      {
        src: "/images/news/news-clip-naturopathy-1.jpg",
        caption: { en: "Natural Therapy Camp Coverage I", hi: "प्राकृतिक चिकित्सा शिविर कवरेज I" },
      },
      {
        src: "/images/news/news-clip-naturopathy-2.jpg",
        caption: { en: "Natural Therapy Camp Coverage II", hi: "प्राकृतिक चिकित्सा शिविर कवरेज II" },
      },
      {
        src: "/images/news/news-clip-naturopathy-3.jpg",
        caption: { en: "Natural Therapy Camp Coverage III", hi: "प्राकृतिक चिकित्सा शिविर कवरेज III" },
      },
      {
        src: "/images/news/news-clip-odia.jpg",
        caption: { en: "Odia Press Report", hi: "ओड़िया प्रेस रिपोर्ट" },
      },
      {
        src: "/images/news/news-clip-english.jpg",
        caption: { en: "English Press Report", hi: "अंग्रेजी प्रेस रिपोर्ट" },
      },
      {
        src: "/images/news/news-clip-matrushakti-1.jpg",
        caption: { en: "Nitidin: Gangaur Fair & Exhibition Concludes", hi: "नितिदिन: गणगौर मेला एवं प्रदर्शनी संपन्न" },
      },
      {
        src: "/images/news/news-clip-matrushakti-2.jpg",
        caption: { en: "Nitidin: Gangaur Fair, 42 Stalls Report", hi: "नितिदिन: गणगौर मेला, 42 स्टॉल रिपोर्ट" },
      },
      {
        src: "/images/news/news-clip-matrushakti-3.jpg",
        caption: { en: "Cuttack: Gangaur Fair Coverage", hi: "कटक: गणगौर मेला कवरेज" },
      },
      {
        src: "/images/news/news-clip-matrushakti-4.jpg",
        caption: { en: "Cuttack: Gangaur Fair Coverage II", hi: "कटक: गणगौर मेला कवरेज II" },
      },
      {
        src: "/images/news/news-clip-matrushakti-5.jpg",
        caption: { en: "Sanmarg: Gangaur Fair & Exhibition Report", hi: "सन्मार्ग: गणगौर मेला एवं प्रदर्शनी रिपोर्ट" },
      },
    ],
    closeLabel: { en: "Close", hi: "बंद करें" },
  },
  marquee: [
    { en: "Uniting The Marwari Community", hi: "मारवाड़ी समाज को एकजुट करते हुए" },
    { en: "7,000+ Members Strong", hi: "7,000+ सदस्य" },
    { en: "Serving Cuttack Since 2009", hi: "2009 से कटक की सेवा में" },
    { en: "President, Cuttack Marwari Samaj", hi: "अध्यक्ष, कटक मारवाड़ी समाज" },
    { en: "Compassion In Action", hi: "करुणा कर्म में" },
  ],
  contact: {
    eyebrow: { en: "Chapter 05: Citizen Connect", hi: "अध्याय 05: जनसंपर्क" },
    heading: { en: "Reach Out. Raise Your Voice.", hi: "संपर्क करें। अपनी आवाज़ उठाएं।" },
    sub: {
      en: "The office doors are always open. Connect directly through any official channel. Every message is read, every voice matters.",
      hi: "कार्यालय के द्वार सदैव खुले हैं। किसी भी आधिकारिक माध्यम से सीधे संपर्क करें। हर संदेश पढ़ा जाता है, हर आवाज़ मायने रखती है।",
    },
    labels: {
      phone: { en: "Phone", hi: "फोन" },
      whatsapp: { en: "WhatsApp", hi: "व्हाट्सऐप" },
      email: { en: "Email", hi: "ईमेल" },
      office: { en: "Office", hi: "कार्यालय" },
    },
    volunteer: { en: "Become a Volunteer", hi: "स्वयंसेवक बनें" },
    volunteerNote: {
      en: "Join 7,000+ Samaj members. Opens WhatsApp.",
      hi: "7,000+ समाज सदस्यों से जुड़ें। व्हाट्सऐप खुलेगा।",
    },
  },
  footer: {
    tagline: {
      en: "Empowering communities through generous service & dedicated leadership.",
      hi: "निस्वार्थ सेवा और समर्पित नेतृत्व से सशक्त बनता समाज।",
    },
    sitemapTitle: { en: "Sitemap", hi: "साइटमैप" },
    connectTitle: { en: "Connect", hi: "जुड़ें" },
    metaTitle: { en: "Meta", hi: "अन्य" },
    compliance: { en: "WCAG 2.2 AA Compliant", hi: "WCAG 2.2 AA अनुरूप" },
    language: { en: "Language", hi: "भाषा" },
    rights: {
      en: "© 2026 Sanjay Sharma. All rights reserved.",
      hi: "© 2026 संजय शर्मा। सर्वाधिकार सुरक्षित।",
    },
    approval: {
      en: "Content approved & published by the Office of Sanjay Sharma.",
      hi: "सामग्री संजय शर्मा कार्यालय द्वारा अनुमोदित एवं प्रकाशित।",
    },
  },
};
